import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

import { UiCommandEvent } from '@ui/cer-ui-types';
import { uiCmdComponentMaximize, uiCmdDocumentDownload, uiCmdDocumentDownloadOriginal, uiCmdDocumentOpenLink } from '@ui/cer-ui-commands';

import { ICerFormViewType } from '@form/cer-form-view-type/cer-form-view-type.interface';
import { CerFormView } from '@form/cer-form-view';
import { CerViewDocumentType, documentTypeByExtension, fileNameExtensionGet, plainUrl } from '@form/cer-form-view-type/cer-form-view-type-document/cer-form-view-document-type';
import { CerPromptService } from '@cer/cer-ui/cer-ui-prompt.service';
import { LinkedAttachmentDto } from '@app/api';
import { CerSessionEnvironmentService } from '@cer/cer-session/cer-session-environment.service';

@Component({
  selector: 'cer-form-view-type-document',
  template: `<ng-template let-view [ngSwitch]="docType">
    <div class="cer-flex cer-flex-main cer-overflow-hidden" [ngClass]="className" [class.cer-maximized]="isMaximized">
    <cer-form-view-type-document-markdown *ngSwitchCase="'markdown'" class="cer-flex cer-flex-main cer-overflow-hidden cer-surface" [view]='view' [documentUrl]="documentUrl" [documentUrlUpdate]="documentUrlUpdate"></cer-form-view-type-document-markdown>
    <cer-form-view-type-document-pdf *ngSwitchCase="'pdf'" class="cer-flex cer-flex-main cer-overflow-hidden"  [view]='view' [documentUrl]="documentUrl"></cer-form-view-type-document-pdf>
    <cer-form-view-type-document-generic *ngSwitchCase="'generic'" class="cer-flex cer-flex-main cer-overflow-hidden cer-surface" [view]='view' [documentUrl]="documentUrl"></cer-form-view-type-document-generic>
    <cer-form-view-type-document-folder *ngSwitchCase="'folder'" class="cer-flex cer-flex-main cer-overflow-hidden cer-surface" [view]='view' [attachment]="attachment"></cer-form-view-type-document-folder>
    <div class="cer-flex cer-flex-main cer-overflow-hidden" *ngSwitchCase="null"><div class="cer-flex cer-flex-main cer-flex-center">Ingen visning</div></div>
    </div>
  </ng-template>`
})

export class CerFormViewTypeDocumentComponent implements ICerFormViewType {
  constructor(private environment: CerSessionEnvironmentService) { }

  @ViewChild(TemplateRef<ICerFormViewType>) template!: TemplateRef<ICerFormViewType>;

  private ui: CerPromptService;
  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    if (view && this._view != view) {
      this.ui = view.routeOptions.context.ui;
      this._view = view;
      this.documentUrl = view.documentUrl;
    }
  }

  private _attachment: LinkedAttachmentDto;
  get attachment(): LinkedAttachmentDto { return this._attachment; };
  @Input() set attachment(attachment: LinkedAttachmentDto) {
    if (attachment && this._attachment != attachment) {
      this.attachment = attachment;
      this.docType = attachment.docType as CerViewDocumentType ?? documentTypeByExtension(fileNameExtensionGet(attachment.fileName));
      this.documentUrl = this.attachment?.url;
    }
  }

  protected docType: CerViewDocumentType;
  protected documentUrlUpdate: string;
  protected className: string;

  private _documentUrl: string;
  get documentUrl(): string { return this._documentUrl };
  @Input() set documentUrl(documentUrl: string) {
    const v = this._view;
    if (documentUrl != this._documentUrl && v != null) {
      this.docType = this.attachment?.docType as CerViewDocumentType ?? documentTypeByExtension(fileNameExtensionGet(this.attachment?.fileName ?? this._view?.documentFileName));
      this.documentUrlUpdate = v.documentUrlUpdate;
      this.className = this.docType?.length > 0 ? "cer-flex-main" : "cer-hidden";
      this._documentUrl = documentUrl;
    }
  }

  protected isMaximized: boolean = false;
  public onCommand(e: UiCommandEvent) {
    switch (e.commandId) {
      case uiCmdComponentMaximize.id:
        this.isMaximized = !this.isMaximized;
        break;
      case uiCmdDocumentOpenLink.id:
        this.documentOpen(plainUrl(this.documentUrl));
        break;
      case uiCmdDocumentDownloadOriginal.id:
        this.documentDownload(this.view?.documentOriginalUrl, this.view?.documentOriginalFileName);
        break;
      case uiCmdDocumentDownload.id:
        this.documentDownload(this.documentUrl, this.view?.documentFileName);
        break;
    }

    if (e.source == 'actionComplete' && e.actionType == 'refreshFromParent') {
      const v = this._view;
      if (v != null) {
        this.documentUrl = v.documentUrl;
      }
    }
  }

  private documentOpen(url: string) {
    if (url?.length > 0) {
      window.open(url, '_');
    }
  }

  private documentDownload(url: string, fileName: string) {
    if (url?.length > 0 && this.ui != null) {
      if (url.startsWith(this.environment.baseUrl)) {
        url += "&asAttachment=1"
      }
      this.ui.downloadUrl(url, fileName);
    }
  }

}